export default [
    {
        path: 'genders',
        name: 'genders',
        meta: {
            modules: [],
            authentication_required: true,
            authorization_required: ['roles.genders.view'],
            translate: (t) => {
                return t('menu_points.genders').ucFirst();
            },
        },
        component: () => import('@/views/helpers/grouper/grouper.vue'),
        redirect: { name: 'genders-list'},
        children: [
            {
                path: '',
                name: 'genders-list',
                meta: {
                    modules: [],
                    authentication_required: true,
                    authorization_required: ['roles.genders.view'],
                    translate: (t) => {
                        return t('menu_points.genders').ucFirst();
                    },
                },
                component: () => import('@/views/pages/system/genders/list.vue')
            },
            {
                path: 'create',
                name: 'gender-create',
                meta: {
                    modules: [],
                    authentication_required: true,
                    authorization_required: ['roles.genders.create'],
                    translate: (t, tc) => t('base.create_new_item', {item: tc('master::genders.gender', 1)}).ucFirst()
                },
                component: () => import('@/views/pages/system/genders/item.vue')
            },
            {
                path: ':id(\\d+)',
                name: 'gender-edit',
                meta: {
                    modules: [],
                    authentication_required: true,
                    authorization_required: ['roles.genders.update'],
                    translate: (t, tc) => t('base.edit_item', {item: tc('master::genders.gender', 1)}).ucFirst()
                },
                component: () => import('@/views/pages/system/genders/item.vue')
            },
        ]
    },
    {
        path: 'countries',
        name: 'countries',
        meta: {
            modules: [],
            authentication_required: true,
            authorization_required: ['roles.countries.view'],
            translate: (t) => {
                return t('menu_points.countries').ucFirst();
            },
        },
        component: () => import('@/views/helpers/grouper/grouper.vue'),
        redirect: { name: 'countries-list'},
        children: [
            {
                path: '',
                name: 'countries-list',
                meta: {
                    modules: [],
                    authentication_required: true,
                    authorization_required: ['roles.countries.view'],
                    translate: (t) => {
                        return t('menu_points.countries').ucFirst();
                    },
                },
                component: () => import('@/views/pages/system/countries/list.vue'),
            },
            {
                path: 'create',
                name: 'country-create',
                meta: {
                    modules: [],
                    authentication_required: true,
                    authorization_required: ['roles.countries.create'],
                    translate: (t, tc) => t('base.create_new_item', {item: tc('master::countries.country', 1)}).ucFirst()
                },
                component: () => import('@/views/pages/system/countries/item.vue')
            },
            {
                path: ':id(\\d+)',
                name: 'country-edit',
                meta: {
                    modules: [],
                    authentication_required: true,
                    authorization_required: ['roles.countries.edit'],
                    translate: (t, tc) => t('base.edit_item', {item: tc('master::countries.country', 1)}).ucFirst()
                },
                component: () => import('@/views/pages/system/countries/item.vue')
            },
        ]
    },
    {
        path: 'languages',
        name: 'languages',
        meta: {
            modules: [],
            authentication_required: true,
            authorization_required: ['roles.languages.view'],
            translate: (t) => {
                return t('menu_points.languages').ucFirst();
            },
        },
        component: () => import('@/views/helpers/grouper/grouper.vue'),
        redirect: { name: 'languages-list'},
        children: [
            {
                path: '',
                name: 'languages-list',
                meta: {
                    modules: [],
                    authentication_required: true,
                    authorization_required: ['roles.languages.view'],
                    translate: (t) => {
                        return t('menu_points.languages').ucFirst();
                    },
                },
                component: () => import('@/views/pages/system/languages/list.vue'),
            },
            {
                path: 'create',
                name: 'language-create',
                meta: {
                    modules: [],
                    authentication_required: true,
                    authorization_required: ['roles.languages.create'],
                    translate: (t, tc) => t('base.create_new_item', {item: tc('intl::languages.language', 1)}).ucFirst()
                },
                component: () => import('@/views/pages/system/languages/item.vue')
            },
            {
                path: ':id(\\d+)',
                name: 'language-edit',
                meta: {
                    modules: [],
                    authentication_required: true,
                    authorization_required: ['roles.languages.update'],
                    translate: (t, tc) => t('base.edit_item', {item: tc('intl::languages.language', 1)}).ucFirst()
                },
                component: () => import('@/views/pages/system/languages/item.vue')
            },
        ]
    },
    {
        path: 'zip-codes',
        name: 'zip-codes',
        meta: {
            modules: [],
            authentication_required: true,
            authorization_required: ['roles.zip_codes.view'],
            translate: (t) => {
                return t('menu_points.zip_codes').ucFirst();
            },
        },
        component: () => import('@/views/helpers/grouper/grouper.vue'),
        redirect: { name: 'zip-codes-list'},
        children: [
            {
                path: '',
                name: 'zip-codes-list',
                meta: {
                    modules: [],
                    authentication_required: true,
                    authorization_required: ['roles.zip_codes.view'],
                    translate: (t) => {
                        return t('menu_points.zip_codes').ucFirst();
                    },
                },
                component: () => import('@/views/pages/system/zip-codes/list.vue')
            },
            {
                path: 'create',
                name: 'zip-code-create',
                meta: {
                    modules: [],
                    authentication_required: true,
                    authorization_required: ['roles.zip_codes.create'],
                    translate: (t, tc) => t('base.create_new_item', {item: tc('master::zip_codes.zip_code', 1)}).ucFirst()
                },
                component: () => import('@/views/pages/system/zip-codes/item.vue')
            },
            {
                path: ':id(\\d+)',
                name: 'zip-code-edit',
                meta: {
                    modules: [],
                    authentication_required: true,
                    authorization_required: ['roles.zip_codes.update'],
                    translate: (t, tc) => t('base.edit_item', {item: tc('master::zip_codes.zip_code', 1)}).ucFirst()
                },
                component: () => import('@/views/pages/system/zip-codes/item.vue')
            },
        ]
    },
    {
        path: 'street-types',
        name: 'street-types',
        meta: {
            modules: [],
            authentication_required: true,
            authorization_required: ['roles.street_types.view'],
            translate: (t) => {
                return t('menu_points.street_types').ucFirst();
            },
        },
        component: () => import('@/views/helpers/grouper/grouper.vue'),
        redirect: { name: 'street-types-list'},
        children: [
            {
                path: '',
                name: 'street-types-list',
                meta: {
                    modules: [],
                    authentication_required: true,
                    authorization_required: ['roles.street_types.view'],
                    translate: (t) => {
                        return t('menu_points.street_types').ucFirst();
                    },
                },
                component: () => import('@/views/pages/system/street-types/list.vue')
            },
            {
                path: 'create',
                name: 'street-type-create',
                meta: {
                    modules: [],
                    authentication_required: true,
                    authorization_required: ['roles.street_types.create'],
                    translate: (t, tc) => t('base.create_new_item', {item: tc('master::street_types.street_type', 1)}).ucFirst()
                },
                component: () => import('@/views/pages/system/street-types/item.vue')
            },
            {
                path: ':id(\\d+)',
                name: 'street-type-edit',
                meta: {
                    modules: [],
                    authentication_required: true,
                    authorization_required: ['roles.street_types.update'],
                    translate: (t, tc) => t('base.edit_item', {item: tc('master::street_types.street_type', 1)}).ucFirst()
                },
                component: () => import('@/views/pages/system/street-types/item.vue')
            },
        ]
    },
    {
        path: 'address-types',
        name: 'address-types',
        meta: {
            modules: [],
            authentication_required: true,
            authorization_required: ['roles.address_types.view'],
            translate: (t) => {
                return t('menu_points.address_types').ucFirst();
            },
        },
        component: () => import('@/views/helpers/grouper/grouper.vue'),
        redirect: { name: 'address-types-list'},
        children: [
            {
                path: '',
                name: 'address-types-list',
                meta: {
                    modules: [],
                    authentication_required: true,
                    authorization_required: ['roles.address_types.view'],
                    translate: (t) => {
                        return t('menu_points.address_types').ucFirst();
                    },
                },
                component: () => import('@/views/pages/system/address-types/list.vue'),
            },
            {
                path: 'create',
                name: 'address-type-create',
                meta: {
                    modules: [],
                    authentication_required: true,
                    authorization_required: ['roles.address_types.create'],
                    translate: (t, tc) => t('base.create_new_item', {item: tc('master::address_types.address_type', 1)}).ucFirst()
                },
                component: () => import('@/views/pages/system/address-types/item.vue')
            },
            {
                path: ':id(\\d+)',
                name: 'address-type-edit',
                meta: {
                    modules: [],
                    authentication_required: true,
                    authorization_required: ['roles.address_types.update'],
                    translate: (t, tc) => t('base.edit_item', {item: tc('master::address_types.address_type', 1)}).ucFirst()
                },
                component: () => import('@/views/pages/system/address-types/item.vue')
            },
        ]
    },
    {
        path: 'field-types',
        name: 'field-types',
        meta: {
            modules: [],
            authentication_required: true,
            authorization_required: ['roles.field_types.view'],
            translate: (t) => {
                return t('menu_points.field_types').ucFirst();
            },
        },
        component: () => import('@/views/helpers/grouper/grouper.vue'),
        redirect: { name: 'field-types-list'},
        children: [
            {
                path: '',
                name: 'field-types-list',
                meta: {
                    modules: [],
                    authentication_required: true,
                    authorization_required: ['roles.field_types.view'],
                    translate: (t) => {
                        return t('menu_points.field_types').ucFirst();
                    },
                },
                component: () => import('@/views/pages/system/field-types/list.vue'),
            },
            {
                path: 'create',
                name: 'field-type-create',
                meta: {
                    modules: [],
                    authentication_required: true,
                    authorization_required: ['roles.field_types.create'],
                    translate: (t, tc) => t('base.create_new_item', {item: tc('dynamic_fields::field_types.field_type', 1)}).ucFirst()
                },
                component: () => import('@/views/pages/system/field-types/item.vue')
            },
            {
                path: ':id(\\d+)',
                name: 'field-type-edit',
                meta: {
                    modules: [],
                    authentication_required: true,
                    authorization_required: ['roles.field_types.update'],
                    translate: (t, tc) => t('base.edit_item', {item: tc('dynamic_fields::field_types.field_type', 1)}).ucFirst()
                },
                component: () => import('@/views/pages/system/field-types/item.vue')
            },
        ]
    },
    {
        path: 'additional-data',
        name: 'additional-data',
        meta: {
            modules: [],
            authentication_required: true,
            authorization_required: ['roles.additional_data.view'],
            translate: (t) => {
                return t('menu_points.additional_data').ucFirst();
            },
        },
        component: () => import('@/views/helpers/grouper/grouper.vue'),
        redirect: { name: 'additional-data-list'},
        children: [
            {
                path: ':type?',
                name: 'additional-data-list',
                meta: {
                    modules: [],
                    authentication_required: true,
                    authorization_required: ['roles.additional_data.view'],
                    translate: (t) => {
                        return t('menu_points.additional_data').ucFirst();
                    },
                },
                component: () => import('@/views/pages/system/additional-data/manager.vue'),
            },
            {
                path: 'create/:type?',
                name: 'additional-data-create',
                meta: {
                    modules: [],
                    authentication_required: true,
                    authorization_required: ['roles.additional_data.create'],
                    translate: (t) => t('base.create_new_item', {item: t('menu_points::additional_data')}).ucFirst()
                },
                component: () => import('@/views/pages/system/additional-data/item.vue')
            },
            {
                path: ':id(\\d+)/:type?',
                name: 'additional-data-edit',
                meta: {
                    modules: [],
                    authentication_required: true,
                    authorization_required: ['roles.additional_data.update'],
                    translate: (t) => t('base.edit_item', {item: t('menu_points::additional_data')}).ucFirst()
                },
                component: () => import('@/views/pages/system/additional-data/item.vue')
            },
        ]
    },
    {
        path: 'currencies',
        name: 'currencies',
        meta: {
            modules: [],
            authentication_required: true,
            authorization_required: ['roles.currencies.view'],
            translate: (t) => {
                return t('menu_points.currencies').ucFirst();
            },
        },
        component: () => import('@/views/helpers/grouper/grouper.vue'),
        redirect: { name: 'currencies-list'},
        children: [
            {
                path: '',
                name: 'currencies-list',
                meta: {
                    modules: [],
                    authentication_required: true,
                    authorization_required: ['roles.currencies.view'],
                    translate: (t) => {
                        return t('menu_points.currencies').ucFirst();
                    },
                },
                component: () => import('@/views/pages/system/currencies/list.vue'),
            },
            {
                path: 'create',
                name: 'currency-create',
                meta: {
                    modules: [],
                    authentication_required: true,
                    authorization_required: ['roles.currencies.create'],
                    translate: (t, tc) => t('base.create_new_item', {item: tc('master::currencies.currency', 1)}).ucFirst()
                },
                component: () => import('@/views/pages/system/currencies/item.vue')
            },
            {
                path: ':id(\\d+)',
                name: 'currency-edit',
                meta: {
                    modules: [],
                    authentication_required: true,
                    authorization_required: ['roles.currencies.edit'],
                    translate: (t, tc) => t('base.edit_item', {item: tc('master::currencies.currency', 1)}).ucFirst()
                },
                component: () => import('@/views/pages/system/currencies/item.vue')
            },
        ]
    },
    {
        path: 'units',
        name: 'units',
        meta: {
            modules: [],
            authentication_required: true,
            authorization_required: ['roles.units.view'],
            translate: (t) => {
                return t('menu_points.units').ucFirst();
            },
        },
        component: () => import('@/views/helpers/grouper/grouper.vue'),
        redirect: { name: 'units-list'},
        children: [
            {
                path: '',
                name: 'units-list',
                meta: {
                    modules: [],
                    authentication_required: true,
                    authorization_required: ['roles.units.view'],
                    translate: (t) => {
                        return t('menu_points.units').ucFirst();
                    },
                },
                component: () => import('@/views/pages/system/units/list.vue'),
            },
            {
                path: 'create',
                name: 'unit-create',
                meta: {
                    modules: [],
                    authentication_required: true,
                    authorization_required: ['roles.units.create'],
                    translate: (t, tc) => t('base.create_new_item', {item: tc('master::units.unit', 1)}).ucFirst()
                },
                component: () => import('@/views/pages/system/units/item.vue')
            },
            {
                path: ':id(\\d+)',
                name: 'unit-edit',
                meta: {
                    modules: [],
                    authentication_required: true,
                    authorization_required: ['roles.units.edit'],
                    translate: (t, tc) => t('base.edit_item', {item: tc('master::units.unit', 1)}).ucFirst()
                },
                component: () => import('@/views/pages/system/units/item.vue')
            },
        ]
    },
]